export const TINTED_PANEL_CLASS =
    "rounded-card bg-doberman-black/[0.03] p-card";
